import { defineMessages } from 'react-intl';

export const smallTextLength = 360;

export const messages = defineMessages({
  about: {
    id: 't.about',
    defaultMessage: 'About',
  },
  showLess: {
    id: 't.showLess',
    defaultMessage: 'Show Less',
  },
  showMore: {
    id: 't.showMore',
    defaultMessage: 'Show More',
  },
} as const);
